import { useQuery } from 'react-query';
import { QUERIES } from '../../../../utils/queris';
import { Components } from '../../../../models/Components';

export const useComponents = () => {
  return useQuery<Components[]>(QUERIES.LOAD_COMPONENTS, () => Components.getAll());
};
